import React from 'react';
import { TERMS_PATH, TERMS_VERSION, PRIVACY_PATH, PRIVACY_VERSION } from '../legal/legalDocuments';

export default function RegistrationLegalAcceptance({ values, errors = {}, onChange, disabled = false }) {
    const checkbox = (name) => ({
        id: `signup-${name}`,
        name,
        type: 'checkbox',
        checked: values[name],
        onChange: event => onChange(name, event.target.checked),
        required: true,
        disabled,
        className: 'ef-signup-consent__checkbox',
        'aria-invalid': Boolean(errors[name]),
        'aria-describedby': errors[name] ? `signup-${name}-error` : undefined,
    });

    const error = (name) => errors[name] && (
        <p id={`signup-${name}-error`} role="alert" className="text-red-500 text-xs mt-1">{errors[name]}</p>
    );

    return (
        <fieldset className="ef-signup-consent-group space-y-4" disabled={disabled}>
            <legend className="font-bold mb-2">Condizioni di iscrizione</legend>
            <p className="text-sm">
                L’account è gratuito. L’iscrizione non attiva abbonamenti né addebiti automatici.
                La visibilità nei risultati di ricerca richiede un abbonamento attivo, da concordare e attivare separatamente.
            </p>
            <div>
                <label className="ef-signup-consent" htmlFor="signup-professionalConfirmed">
                    <input {...checkbox('professionalConfirmed')} />
                    <span>Dichiaro di essere maggiorenne e di agire come titolare, legale rappresentante o delegato autorizzato dell’agenzia, per finalità professionali.</span>
                </label>
                {error('professionalConfirmed')}
            </div>
            <div>
                <label className="ef-signup-consent" htmlFor="signup-termsAccepted">
                    <input {...checkbox('termsAccepted')} />
                    <span>Ho letto e accetto le <a href={TERMS_PATH} target="_blank" rel="noopener noreferrer">Condizioni di servizio per le agenzie</a> (versione {TERMS_VERSION}).</span>
                </label>
                {error('termsAccepted')}
            </div>
            <div>
                <label className="ef-signup-consent" htmlFor="signup-privacyAcknowledged">
                    <input {...checkbox('privacyAcknowledged')} />
                    <span>Ho letto l’<a href={PRIVACY_PATH} target="_blank" rel="noopener noreferrer">informativa sul trattamento dei dati personali</a> (versione {PRIVACY_VERSION}).</span>
                </label>
                {error('privacyAcknowledged')}
            </div>
        </fieldset>
    );
}
